import { DeleteFilled, InfoCircleOutlined, ReloadOutlined } from '@ant-design/icons'
import { Popconfirm, Switch, Tooltip } from 'antd'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const PopupConfirm = props => {
  const {
    onConfirm = () => {}, name = '', type = 'status', title: customTitle,
    size = 'small', checked, disabled, disableTitle, className, render
  } = props

  const { t: ln_t } = useTranslation()

  const popupConf = {
    icon: <InfoCircleOutlined style={{ color: '#242a30' }} />,
    okText: ln_t('util.confirm'),
    cancelText: ln_t('util.cancel'),
    placement: 'left'
  }

  const title = useMemo(() => {
    let t = ''
    switch (type) {
      case 'status':
        t = `${checked ? ln_t('util.disable') : ln_t('util.enable')} ${name} ?`
        break
      case 'role':
        t = `${ln_t('util.modifyRole')} ?`
        break
      case 'delete':
        t = `${ln_t('util.delete')} ${name} ?`
        break
      case 'preview':
        t = `${ln_t('util.preview')} ${name} ?`
        break
      case 'custom':
        t = customTitle
        break
      default:
        break
    }
    return t
  }, [type, checked, name])

  const elem = useMemo(() => {
    let n = null
    switch (type) {
      case 'status':
        n = (
                <Switch
                    checkedChildren={ln_t('util.enable')}
                    unCheckedChildren={ln_t('util.disable')}
                    disabled={disabled}
                    size={size}
                    checked={checked}
                    style={{ whiteSpace: 'nowrap' }}
                />
        )
        break
      case 'role':
        n = (
                <Switch
                    checkedChildren={ln_t('util.role.admin')}
                    unCheckedChildren={ln_t('util.role.member')}
                    disabled={disabled}
                    size={size}
                    checked={checked}
                    style={{ whiteSpace: 'nowrap', width: '71px' }}
                />
        )
        break
      case 'delete':
        n = <DeleteFilled className={className} />
        break
      case 'preview':
        n = <ReloadOutlined className={className} />
        break
      case 'custom':
        n = render()
        break
      default:
        break
    }
    return n
  }, [type, checked, ln_t])

  return (
    !elem
      ? ''
      : disabled
        ? (
                <Tooltip title={disableTitle}>
                    {elem}
                </Tooltip>
          )
        : (
                <Popconfirm title={title} onConfirm={() => onConfirm()} {...popupConf}>
                    {elem}
                </Popconfirm>
          )
  )
}

export default PopupConfirm
